export const getMoscowDateTime = () => {
  const moscowTZ = -180 //Moscow timezone
  const currentDate = new Date()

  //Moscow current Date
  return new Date(currentDate.getTime() + 60000 * (currentDate.getTimezoneOffset() - moscowTZ))
}
